import React from 'react';
import { Space, Typography } from 'antd';
import { DashboardRefreshButton, DashboardSearchInput } from '../components/dashboard';

const { Text, Title } = Typography;

export default function OperatorForkliftToolbar({
  busy,
  hasMultipleCustomers,
  onRefresh,
  search,
  setSearch,
  shownCount,
}) {
  return (
    <div className="operator-dashboard-toolbar">
      <div className="operator-dashboard-heading">
        <Title level={3}>Forklifts</Title>
        <Text type="secondary" className="operator-dashboard-helper-text">
          Select a unit to begin a pre-shift checklist.
          {hasMultipleCustomers ? '' : ''}
        </Text>
        <Text type="secondary" className="operator-dashboard-count" aria-live="polite">
          Showing {shownCount} {shownCount === 1 ? 'unit' : 'units'}
        </Text>
      </div>

      <Space wrap className="operator-dashboard-controls">
        <DashboardSearchInput
          placeholder="Search forklifts"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="operator-dashboard-search"
          ariaLabel="Search forklifts"
        />
        <DashboardRefreshButton
          loading={busy}
          onClick={onRefresh}
          className="operator-dashboard-refresh"
        />
      </Space>
    </div>
  );
}
